import sdk from '../../../services/service-awards-sdk';

/*******************************************************************************
 * Initial state
 */
const initialState = {
};

/*******************************************************************************
 * Non-async action types
 */
const SET_STATE = 'settings/setState';
const CLEAR_STATE = 'settings/clearState';

/*******************************************************************************
 * Reducer
 */
export default function settingsReducer( state = initialState, action ) {

    switch ( action.type ) {
        case SET_STATE: {
            return {
                ...state,
                ...action.state
            };
        }
        case CLEAR_STATE: {
            return {
                state
            };
        }
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */

function loadPreferences() {
    return ( dispatch ) => {

        return sdk.getPreferences()
            .then( ( preferences ) => {
                dispatch( setState( preferences ) );

                return preferences;
            } )
            .catch( ( err ) => {
                console.log( err );
                return {};
            } );
    };
}
function loadAllProcedures() {
    return ( dispatch ) => {

        return sdk.loadAllProcedures()
            .then( ( procedures ) => {

                dispatch( setState( { procedures: procedures.procedures } ) );
                return procedures;
            } )
            .catch( ( err ) => {
                console.log( err );
                return [];
            } );
    };
}
function updatePreferences( preferences ) {
    return ( dispatch ) => {
        return sdk.updatePreferences( preferences )
            .then( ( preferences ) => {
                return preferences;
            } )
            .catch( ( err ) => {
                console.log( err );
                return {};
            } );
    };
}
function setState( state ) {
    return {
        type: SET_STATE,
        state
    };
}
function clearState() {
    return {
        type: CLEAR_STATE
    };
}



export const actions = {
    setState,
    loadPreferences,
    updatePreferences,
    clearState,
    loadAllProcedures
};
